import { Layout } from 'antd';
import styled from 'styled-components';
import { APP_SHELL_THEME } from '@/styles/appShellTheme';

export const SectionHeader = styled(Layout.Header)`
  position: relative;
  display: flex;
  align-items: center;
  /* Title left, actions right — the standard page-header arrangement, and what
     lets a page hang its primary action off the header instead of floating it
     above the content. */
  justify-content: space-between;
  gap: 16px;
  min-height: 64px;
  height: auto;
  background-color: ${APP_SHELL_THEME.pageBg} !important;
  border-bottom: 1px solid ${APP_SHELL_THEME.panelBorder};
  padding: 16px 24px;
  line-height: 1.3;

  /* Actions drop below the title rather than squeezing it off the screen. */
  @media (max-width: 576px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

/** Title and its optional subtitle, kept together at the start of the bar. */
export const TitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const SectionTitle = styled.h1`
  margin: 0;
  /* Sentence case at a readable size: the previous uppercase treatment with
     wide tracking cost legibility on longer page names and gave every page the
     same shouted emphasis. */
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: ${APP_SHELL_THEME.text};
  /* Wraps rather than truncating: a clipped page name is worse than one that
     takes two lines, and page titles are short enough that it rarely happens. */
  text-wrap: balance;
`;

export const SectionSubtitle = styled.p`
  margin: 0;
  font-size: 13px;
  font-weight: 400;
  color: ${APP_SHELL_THEME.textMuted};
  text-wrap: pretty;
`;

/** Page-level actions, pinned to the end of the bar. */
/** Page-level actions, pinned to the end of the bar. */
export const SectionActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
`;
